import { Components } from "../stores/types";
import WebhookSwitch from "../features/forms/WebhookSwitch";
import FrigadeOnBoarding from "../components/frigadeOnBoarding";
import SvixWrapper from "../components/svixWrapper";

const components: Components = {
  importerSettings: WebhookSwitch,
  settingsPage: SvixWrapper,
  mainPage: FrigadeOnBoarding,
};

export default components;
